<div class="mx-auto flex max-w-7xl items-center gap-x-6 py-2.5 px-6 lg:px-8 justify-between">
  <div
    class="hidden lg:flex items-center text-xs rounded-md gap-x-4 px-4 py-1 leading-6 text-slate-500 ring-1 ring-gray-900/10">
    <div class="flex items-center gap-x-2 ng-star-inserted">
      <span class="font-semibold text-primary-500">{{ 'NAV.STATS.1.VALUE' | translate }}</span>
      <span>{{ 'NAV.STATS.1.TITLE' | translate }}</span>
      <span class="ml-2 h-4 w-px bg-gray-900/10 ng-star-inserted"></span>
    </div>
    <div class="flex items-center gap-x-2 ng-star-inserted">
      <span class="font-semibold text-primary-500">{{ 'NAV.STATS.2.VALUE' | translate }}</span>
      <span>{{ 'NAV.STATS.2.TITLE' | translate }}</span>
      <span class="ml-2 h-4 w-px bg-gray-900/10 ng-star-inserted"></span>
    </div>
    <div class="flex items-center gap-x-2 ng-star-inserted">
      <span class="font-semibold text-primary-500">{{ 'NAV.STATS.3.VALUE' | translate }}</span>
      <span>{{ 'NAV.STATS.3.TITLE' | translate }}</span>
    </div>
  </div>
  <div class="flex items-center ng-star-inserted">
    <div>
      <div class="flex items-center">
        <svg class="h-5 w-5 flex-shrink-0 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
          <path
            clip-rule="evenodd"
            d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401z"
            fill-rule="evenodd"></path>
        </svg>
        <svg class="h-5 w-5 flex-shrink-0 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
          <path
            clip-rule="evenodd"
            d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401z"
            fill-rule="evenodd"></path>
        </svg>
        <svg class="h-5 w-5 flex-shrink-0 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
          <path
            clip-rule="evenodd"
            d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401z"
            fill-rule="evenodd"></path>
        </svg>
        <svg class="h-5 w-5 flex-shrink-0 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
          <path
            clip-rule="evenodd"
            d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401z"
            fill-rule="evenodd"></path>
        </svg>
        <svg class="h-5 w-5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path
            class="fill-gray-300"
            clip-rule="evenodd"
            d="M10.868 2.88405C10.547 2.11205 9.45304 2.11205 9.13204 2.88405L7.30204 7.28505L2.54904 7.66605C1.71604 7.73305 1.37804 8.77305 2.01304 9.31705L5.63304 12.4191L4.52704 17.0561C4.33304 17.8691 5.21804 18.5121 5.93204 18.0761L10 15.5911L14.069 18.0761C14.782 18.5121 15.667 17.8691 15.473 17.0561L14.367 12.4191L17.987 9.31705C18.622 8.77305 18.284 7.73305 17.451 7.66705L12.699 7.28505L10.868 2.88405Z"
            fill-rule="evenodd"></path>
          <path
            class="fill-yellow-400"
            d="M9.13204 2.88405C9.45304 2.11205 10.547 2.11205 10.868 2.88405L12.699 7.28505V17.2394L10 15.5911L5.93204 18.0761C5.21804 18.5121 4.33304 17.8691 4.52704 17.0561L5.63304 12.4191L2.01304 9.31705C1.37804 8.77305 1.71604 7.73305 2.54904 7.66605L7.30204 7.28505L9.13204 2.88405Z"></path>
        </svg>
      </div>
    </div>
    <p class="ml-2 text-sm text-gray-900"><strong>4.8/5</strong> - 4865 {{ 'COMMON.ADVICES' | translate }}</p>
  </div>
</div>
